import { useHistory } from "react-router";
import Tooltip from "../Tooltip";
import { ButtonComponent } from "./styles";

export const LinkButton = ({ children, icon, path, search = "", disabled = false, tooltip = undefined, ...rest }) => {
  const history = useHistory();

  const handleClick = () => {
    if (!disabled) {
      history.push({
        pathname: path,
        search: search,
      });
    }
  };

  const content = (
    <ButtonComponent onClick={handleClick} disabled={disabled} {...rest}>
      <p>
        {icon}
        {children}
      </p>
    </ButtonComponent>
  );

  if (!tooltip) return content;

  return (
    <Tooltip title={tooltip}>
      <span style={{ display: "inline-block", width: "100%" }}>{content}</span>
    </Tooltip>
  );
};
